import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { CONTACT } from '../mock';

export default function Reviews() {
  return (
    <section className="bg-[#f5f5f7] py-20">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="rounded-2xl bg-white border border-slate-200 p-10 md:p-12 flex flex-col md:flex-row items-center gap-10">
          <div className="text-center md:text-left">
            <div className="font-heading font-extrabold text-[64px] leading-none text-[#0f1a2b]">5,0</div>
            <div className="mt-3 flex items-center justify-center md:justify-start gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#f5c518] text-[#f5c518]" />
              ))}
            </div>
          </div>
          <div className="hidden md:block h-24 w-px bg-slate-200" />
          <div className="flex-1">
            <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-2">OPINIE GOOGLE</div>
            <div className="font-heading font-extrabold text-[28px] md:text-[32px] tracking-tight text-[#0f1a2b]">Opinie klientów</div>
            <p className="mt-2 text-[14px] text-[#0f1a2b]/70">Zobacz oceny wystawione w wizytówce Google.</p>
            <a href={CONTACT.google} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center gap-2 bg-[#f5c518] hover:bg-[#eab308] text-[#0f1a2b] font-semibold text-[14px] px-5 py-3 rounded-full transition-colors">
              <MapPin className="h-4 w-4" /> Zobacz wizytówkę Google
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
